/**
 * Created by pzf on 19/9/1.
 *
 */
/* eslint func-names: 1 */
import React, { Fragment } from 'react';
import { TagsSelect, TransferModal } from 'mkui-ext';
import { defaultPropTypes, propTypes } from './PropTypes';

class FeeTypeTagsSelect extends React.Component {
  /** *******************static************************** */
  static propTypes = propTypes;

  static defaultProps = defaultPropTypes;

  /** *******************life cycle************************** */
  constructor(props) {
    super(props);
    this.state = {
      value: props.value ? props.value : [],
      visible: false,
    };
  }

  clickHandle() {
    this.setState({ visible: true });
  }

  cancleHandle() {
    this.setState({ visible: false });
  }

  okHandle(data) {
    this.setState({
      value: data,
      visible: false,
    });
    this.fireChange(data);
  }


  fireChange(choosed) {
    const { onChange } = this.props;
    onChange(choosed);
  }

  render() {
    const { multiple, api, placeholder, label, showLabel } = this.props;
    const { visible, value } = this.state;
    return (
      <Fragment>
        <TagsSelect
          label={label}
          value={value}
          render={item => item.feeTypeName}
          keyName="feeTypeCode"
          onClick={() => {
            this.clickHandle();
          }}
          placeholder={placeholder}
          showLabel={showLabel}
        />
        <TransferModal
          title={`${label}选择`}
          subTitle="费用类型"
          value={value}
          visible={visible}
          multiple={multiple}
          api={api}
          showSearch={false}
          keyName="feeTypeCode"
          categoryKeyName="categoryCode"
          render={item => item.feeTypeName}
          categoryRender={item => item.categoryName}
          onCancle={() => {
            this.cancleHandle();
          }}
          onOk={(data) => {
            this.okHandle(data);
          }}
        />
      </Fragment>
    );
  }
}

export default FeeTypeTagsSelect;
